import { IFormGroup } from "../../Interface/IFormGroup";
import {
	ToolName,
	ToolVersion,
	ToolType,
	Channels,
	IsActive,
	IsWppActive,
	ToolState,
	ToolStatus,
	ToolLabel,
	ToolPlatforms,
	Madeby,
	ShortDescription,
	LongDescription,
	CreatedBy,
	CreatedDate,
	ToolThumbnail,
	ToolScriptPath,
	ToolURL,
	ToolInfoURL,
	AuthLoginContent,
	FormSubmitAPIEndpoint,
	FormUpdateAPIEndpoint,
	IsFileDownloadAPI,
	LoadLastSavedData,
	ToolFormType,
	ModifiedBy,
	ModifiedDate,
	ToolLifeCycle,
	ToolAZGroups,
	IsMaintenance,
	ResetAuthorization,
	IsGrid,
	IsSchedule,
	IsServiceAccountAuth,
	ToolPersistButton,
	PortalFlag,
	WppFlag,
	Description,
	StartDate,
	EndDate,
	PortalMaintenanceFlag
} from "./FormElements";


export const ToolGroup: IFormGroup = {
	id:"toolgroup",
	elements: [
		ToolName, 
		ToolVersion,
		IsActive,
		IsWppActive, 
		IsMaintenance,
		ToolAZGroups,
		ShortDescription,
		LongDescription,
		ToolType,
		ToolLifeCycle,
		ToolStatus, 
		ToolLabel,
		ToolPlatforms,
		ToolState,
		ToolFormType,
		IsServiceAccountAuth,
		AuthLoginContent,
		FormSubmitAPIEndpoint,
		FormUpdateAPIEndpoint,
		IsFileDownloadAPI,
		IsGrid,
		IsSchedule,
		ToolPersistButton,
		LoadLastSavedData,
		Madeby,
		Channels,
		ToolScriptPath,
		ToolURL,
		ToolInfoURL,
		CreatedBy,
		CreatedDate,
		ModifiedBy,
		ModifiedDate,
		ResetAuthorization,
		ToolThumbnail,
	],
	isVisible: true,
	title: ""
};


export const ToolGroupMaintenence: IFormGroup = {
	id:"toolgroup",
	elements: [
		PortalFlag,
		WppFlag,
		Description,
		StartDate,
		EndDate
	],
	isVisible: true,
	title: ""
};

export const ToolGroupPortalMaintenence: IFormGroup = {
	id:"toolgroup",
	elements: [
		PortalMaintenanceFlag
	],
	isVisible: true,
	title: ""
};
